import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useProjectTracker() {
    const location = useLocation();

    useEffect(() => {
        trackProjectLocation(location.pathname);
    }, [location]);
}

export function trackProjectLocation(pathname: string) {
    if (pathname.includes('/projects')) {
        localStorage.setItem('wasOnProjects', 'true');
    } else {
        localStorage.setItem('wasOnProjects', 'false');
    }
}